export const FaqList = [
    {
        index: 0,
        title: {
            content: 'Faturalarımı Paycell den nasıl ödeyebilirim ?',
            icon: 'question'
        },
        content: {
            content:
                (
                    <span>
                    Elektrik,su,doğalgaz,internet ,telefon ,tv vb tüm faturalarını Paycell uygulamasından ve bütün Turkcell
                    noktalarından ödeyebilirsin.Ayrıca Paycell logosunu gördüğün tüm anlaşmalı üye işyerlerinde de ödemelerini
                    kolay ve hızlı bir şekilde yapabilirsin.
                    </span>
                ),
        }
    },
    {
        index: 1,
        title: {
            content: 'Faturalarımı nakit yada kartla ödeyebilir miyim?',
            icon: 'question'
        },
        content: {
            content:
                (
                    <span>
                    Elektrik,su,doğalgaz,internet ,telefon ,tv vb tüm faturalarını ister Nakit ister Banka kartı,Kredi kartı ve Paycell kart ile ödeyebilirsin.
                    </span>
                ),
        }
    },
    {
        index: 2,
        title: {
            content: 'Faturalarım için otomatik ödeme talimatı verebilir miyim?',
            icon: 'question'
        },
        content: {
            content:
                (
                    <span>
                    Şuan sadece Turkcell faturalarını otomatik ödemeye verebilirsin. Otomatik ödeme talimatı
                        konusunda kendimizi geliştiyoruz. Çok yakında bütün kurumlar için otomatik ödeme talimatı
                        verebileceksin. O zamana kadar;  Paycell Uygulaması içerisinde faturanı öderken ‘’Faturamı Kaydet ‘’
                        tuşuna basarak Faturanı kaydedip birsonraki fatura ödemende fatura bilgilerini girmeden hızlıca
                        faturanı ödeyebilirsin.
                    </span>
                ),
        }
    },

    {
        index: 3,
        title: {
            content: 'Başka Bankada faturalarımın otomatik ödemede olması Paycell Uygulamasından yada Turkcell noktalarından faturamı ödememe bir engel midir?',
            icon: 'question'
        },
        content: {
            content:
                (
                    <span>
                        Hayır tabiki engel değildir.Faturaların bir Bankada otomatik ödemede olsa dahi son ödeme tarihi gelmeden faturanı Paycell uygulamasından
                        Turkcell noktalarından ve  Paycell logosunu gördüğün tüm anlaşmalı üye işyerlerinden ödeyebilirsin.
                    </span>
                ),
        }
    },
    {
        index: 4,
        title: {
            content: 'Paycell uygulamasını nasıl ve nereden indirebilirim?',
            icon: 'question'
        },
        content: {
            content:
                (
                    <span>
                        Paycell uygulamasını İOS larda APP Store ‘a PAYCELL yazarak, Android cihazlarda ise Playstore’a PAYCELL yazarak hemen şimdi ücretsiz olarak indirebilir ve kullanmaya başlayabilirsin.
                        İOS için tıkla.
                        Andorid için tıkla.
                    </span>
                ),
        }
    },
        {
        index: 5,
        title: {
            content: 'Fatura öderken ücret öder miyim?',
            icon: 'question'
        },
        content: {
            content:
                (
                    <span>
                        Paycell Uygulamasından ödeyeceğin bütün fatura ödemeleri ücretsizdir. (sadece Financell taksit ödemeleri ücretlidir)
                        Turkcell noktaları ve Paycell logosu gördüğün anlaşmalı üye işyerlerinde geçerli ücretlerimiz için linki tıklayabilirsin.
                    </span>
                ),
        }
    },
            {
        index: 6,
        title: {
            content: 'Paycell Uygulamasından öderken yanlış fatura ödedim ,ne yapmalıyım?',
            icon: 'question'
        },
        content: {
            content:
                (
                    <span>
                        Faturanı Paycell uygulamasından ödedi isen hemen 0850 622 60 60 yi arayarak yanlış ödediğin faturanı iptal edebilirsin.
                    </span>
                ),
        }
    },
    {
        index: 7,
        title: {
            content: 'Turkcell noktalarından / anlaşmalı üye işyerlerinden öderken yanlış fatura ödedim ,ne yapmalıyım?',
            icon: 'question'
        },
        content: {
            content:
                (
                    <span>
                        Faturanı ödediğin aynı gün içinde ödeme yaptığın yere giderek iptalini talep edebilirsin.
                        Eğer yanlış ödediğini ertesi gün farkettiysen faturanın bağlı olduğu kurum ile iletişime geçmelisin.
                    </span>
                ),
        }
    },
    {
        index: 8,
        title: {
            content: 'Paycell uygulamasında fatura bilgilerimi giriyorum ama faturam çıkmıyor, neden?',
            icon: 'question'
        },
        content: {
            content:
                (
                    <span>
                        Sistemde bazen teknik problemler yaşanabiliyor.Faturanın daha önce farklı bir kanaldan ödemediğinden eminsen bir süre sonra tekrar denemeni tavsiye ederiz.
                    </span>
                ),
        }
    },
    {
        index: 9,
        title: {
            content: 'Paycell uygulamasından veya Turkcell noktalarından faturamı ödemedim ancak Kurumda faturam hala ödenmemiş olarak gözüküyor, ne yapmalıyım? ',
            icon: 'question'
        },
        content: {
            content:
                (
                    <span>
                        Ödemiş olduğun faturanı bir gün sonra tekrar kontrol etmeni rica ederiz, ödenmiş olarak göreceksin.Çünkü sistemsel kayıtlar akşamları geç saatlerde güncelleniyor.
                        Ertesi gün faturanı hala ödenmemiş olarak görürsen lütfen hemen bize telefon yada maille haber verebilirsin.
                        Telefon Numaramız:  0850 622 60 60
                        E-mail adresimiz:  info@paycell.com.tr
                    </span>
                ),
        }
    },
    {
        index: 10,
        title: {
            content: 'Paycell uygulamasından ödemiş olduğum faturalarımın dekontları lazım olursa nasıl temin edeceğim?',
            icon: 'question'
        },
        content: {
            content:
                (
                    <span>
                        Paycell uygulaması içerisinde Fatura menüsünde geçmişe dönük işlemleri listeleyebilir ,dekontlarını istediğin zaman alabilirsin.
                    </span>
                ),
        }
    },
    {
        index: 11,
        title: {
            content: 'Turkcell noktalarından ödemiş olduğum faturalarımın dekontları lazım olursa nasıl temin edeceğim?',
            icon: 'question'
        },
        content: {
            content:
                (
                    <span>
                        Faturanı ödediğin Turkcell noktasına giderek  geçmişe dönük faturanı talep edersen sana yardımcı olacaklardır.
                    </span>
                ),
        }
    },

    {
        index: 12,
        title: {
            content: 'Soru ve şikayetlerimi nereye iletebilirim?',
            icon: 'question'
        },
        content: {
            content:
                (
                    <span>
                        Mail adresi: info@paycell.com.tr
                        Telefon : 0850 622 60 60
                    </span>
                ),
        }
    }
];